import React from 'react';
import PropTypes from 'prop-types';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Checkbox,
  // Tooltip,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  checkBoxCell: {
    width: 90,
  },
};

const rows = [
  { id: 'itemNumber', numeric: false, label: 'Item Number' },
  { id: 'packageType', numeric: false, label: 'Package Type' },
  { id: 'quantity', numeric: false, label: 'Pieces/Quantity' },
  { id: 'commodity', numeric: false, label: 'Commodity' },
  { id: 'grossWeight', numeric: false, label: 'Gross Weight' },
  { id: 'customsStatus', numeric: false, label: 'Customs Status' },
  { id: 'equipment', numeric: false, label: 'Equipment' },
  { id: 'copy', numeric: false, label: 'Copy' },
];

class BillOfLadingDetailsTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, classes } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox" className={classes.checkBoxCell}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                sortDirection={orderBy === row.id ? order : false}
              >
                {/* <Tooltip
                  title="Sort"
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                > */}
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    {row.label}
                  </TableSortLabel>
                {/* </Tooltip> */}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }
}

BillOfLadingDetailsTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BillOfLadingDetailsTableHead);
